import React from 'react';
import {Link} from 'react-router-dom';
import config from '../config';

import '../scss/CompeticionHeaderMenu.css';
import IconFavoriteBorder from '../icons/IconFavoriteBorder';
import IconSearch from '../icons/IconSearch';
import IconPodium from '../icons/IconPodium';
import IconCrown from '../icons/IconCrown';
import IconSatellite from '../icons/IconSatellite';

const CompeticionHeaderMenu = (props) => {
  const selected = props.selected || 1

  if (props.competicion && props.competicion.visible) {
    return <ul className={`competicion-options`}>
      <li className={`competicion-options__item ` + (selected === 1 ? 'competicion-options__item--active' : '')}>
        <Link to={`/competicion/${props.competicion.id}`}>
          <div className='competicion-options__item-icon'><IconPodium
            fill={selected === 1 ? config.COLOR_BUTTON_ON : config.COLOR_BUTTON_OFF} /></div>
          <div className='competicion-options__item-text'>Líderes</div>
        </Link>
      </li>
      { props.competicion.ranking_numero > 0 &&
        <li className={`competicion-options__item ` + (selected === 2 ? 'competicion-options__item--active' : '')}>
          <Link to={`/competicion/${props.competicion.id}/ranking`}>
            <div className='competicion-options__item-icon'>
              <IconCrown className='competicion-options__item-icon'
                fill={selected === 2 ? config.COLOR_BUTTON_ON : config.COLOR_BUTTON_OFF} />
            </div>
            <div className='competicion-options__item-text'>Rankings</div>
          </Link>
        </li>
      }
      <li className={`competicion-options__item ` + (selected === 3 ? 'competicion-options__item--active' : '')}>
        <Link to={`/competicion/${props.competicion.id}/favoritos`}>
          <div className='competicion-options__item-icon'>
            <IconFavoriteBorder className='competicion-options__item-icon'
              fill={selected === 3 ? config.COLOR_BUTTON_ON : config.COLOR_BUTTON_OFF} />
          </div>
          <div className='competicion-options__item-text'>Favoritos</div>
        </Link>
      </li>
      <li className={`competicion-options__item ` + (selected === 4 ? 'competicion-options__item--active' : '')}>
        <Link to={`/competicion/${props.competicion.id}/buscar`}>
          <div className='competicion-options__item-icon'>
            <IconSearch className='competicion-options__item-icon'
              fill={selected === 4 ? config.COLOR_BUTTON_ON : config.COLOR_BUTTON_OFF} />
          </div>
          <div className='competicion-options__item-text'>Buscar Atletas</div>
        </Link>
      </li>
      {(props.competicion.mapa_geojson && props.competicion.trackers && props.competicion.trackers.length > 0) &&
        <li className={`competicion-options__item ` + (selected === 5 ? 'competicion-options__item--active' : '')}>
          <Link to={`/competicion/${props.competicion.id}/gps`}>
            <div className='competicion-options__item-icon'>
              <IconSatellite
                className='competicion-options__item-icon'
                fill={selected === 5 ? config.COLOR_BUTTON_ON : config.COLOR_BUTTON_OFF}
              />
            </div>
            <div className='competicion-options__item-text'>Seguimiento GPS</div>
          </Link>
        </li>
      }
    </ul>
  } else {
    return <div> <br /> <br />
      <h2 className={'text-center'}>No se ha podido encontrar la competición especificada</h2>
    </div>
  }
}

export default CompeticionHeaderMenu



// WEBPACK FOOTER //
// ./src/components/CompeticionHeaderMenu.js